"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const CrossIcon_1 = require("../../assets/icons/CrossIcon");
const material_1 = require("@mui/material");
const Typography_1 = require("../Typography");
const custom_drawer_styles_1 = require("./custom-drawer.styles");
const CustomDrawer = (_a) => {
    var { anchor, title, subTitle, children, open = false, closeHandler, className } = _a, rest = __rest(_a, ["anchor", "title", "subTitle", "children", "open", "closeHandler", "className"]);
    const styles = (0, custom_drawer_styles_1.default)();
    return ((0, jsx_runtime_1.jsx)(material_1.Drawer, Object.assign({ open: open, anchor: anchor, sx: styles.container, className: className, transitionDuration: {
            enter: 500,
            exit: 500,
        }, PaperProps: { sx: styles.paper }, ModalProps: {
            sx: styles.container,
        } }, rest, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: styles.content, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: styles.header, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: styles.titleContainer, children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { typo: "title_lg", sx: styles.title, children: title !== null && title !== void 0 ? title : '\u00A0' }), (0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: closeHandler, children: (0, jsx_runtime_1.jsx)(CrossIcon_1.default, {}) }) })] }), (0, jsx_runtime_1.jsx)(Typography_1.default, { typo: "body_sm", sx: styles.subTitle, children: subTitle !== null && subTitle !== void 0 ? subTitle : '\u00A0' })] }), (0, jsx_runtime_1.jsx)(material_1.Box, { children: children })] }) })));
};
exports.default = CustomDrawer;
